import { IGetSupplierResponseData } from '@modules/accounting-and-finance/interface/suppliers/supplier.interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: IGetSupplierResponseData[] = [];

export const ACCGSuppliersSlice = createSlice({
  name: 'accgSuppliers',
  initialState,
  reducers: {
    setACCGSuppliers: (
      _state,
      action: PayloadAction<IGetSupplierResponseData[]>,
    ) => {
      return [...action.payload];
    },
    removeACCGSuppliers: () => {
      return initialState;
    },
  },
});

export default ACCGSuppliersSlice.reducer;

export const { setACCGSuppliers, removeACCGSuppliers } =
  ACCGSuppliersSlice.actions;
